import React from "react";
import Story from "./Story";
import "./StoryReel.css";

function StoryReel() {
  return (
    <div className="storyReel">
      <Story
        image="https://mk0laterblogouwugirk.kinstacdn.com/wp-content/uploads/2019/01/How-Often-to-Post-to-Facebook-Stories.png"
        profileSrc="https://samuel46.github.io/SamuelPortfolio/images/Profile.jpeg"
        title="Samuel Wanjiru"
      />
      <Story
        image="https://webcdn-adespressoinc.netdna-ssl.com/wp-content/uploads/2019/11/Screen-Shot-2019-11-04-at-1.12.08-AM-555x1024.png"
        profileSrc="https://imagez.tmz.com/image/54/4by3/2019/07/10/54d26ff1e33b49d8b5b48b5e9dbfeda8_md.jpg"
        title="Talyor"
      />
      <Story
        image="https://webcdn-adespressoinc.netdna-ssl.com/wp-content/uploads/2019/11/Screen-Shot-2019-11-04-at-1.11.30-AM-479x1024.png"
        profileSrc="https://cdn.trendhunterstatic.com/thumbs/matthias-clamer.jpeg"
        title="Will Smith"
      />
      <Story
        image="https://cnet3.cbsistatic.com/img/VPloalVxxUVcu1mlmmrqMmyhWE0=/940x0/2017/04/13/5e54c3cd-17f3-4af9-8415-dbda2d5a6bfa/instagram-selfie-sticker.png"
        profileSrc="https://mymodernmet.com/wp/wp-content/uploads/archive/WopfAi2CDedg9Egxw7XF_gesichtermix2.jpg"
        title="Morgan "
      />
      <Story
        image="https://i.pinimg.com/564x/30/ac/e8/30ace88d2dca51b465ea3b8cb9d8b9a0.jpg"
        profileSrc="https://media.allure.com/photos/59d3c2da93ac4d238f1582c4/3:4/w_1990,h_2653,c_limit/celeb-fragrances-triptych.jpg"
        title="ariana grande "
      />
    </div>
  );
}

export default StoryReel;
